// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"800aaee6","453":"775febc2"}[chunkId] + ".chunk.js";
};